import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterWestBeach() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-west-beach",
    name: "Painters West Beach",
    location: "West Beach, Cape Town",
    rating: 4.7,
    reviews: 138,
    specialties: ["Coastal Properties", "Beachfront Homes", "Marine-Grade Finishes", "Holiday Properties"],
    image: "https://public.readdy.ai/ai/img_res/1024a1f70cbc165278cc5a8aa232bcea.jpg",
    verified: true,
    yearsExperience: 13,
    website: "https://painterswestbeach.co.za",
    email: "info@painterswestbeach.co.za",
    phone: "+27 21 555 0132",
    description: "Professional painting services in West Beach and surrounding coastal areas. We specialize in beachfront properties with expertise in marine-grade finishes that withstand Atlantic Ocean conditions and coastal weather.",
    services: [
      "Interior House Painting",
      "Exterior House Painting", 
      "Beachfront Property Painting",
      "Holiday Home Painting",
      "Roof Painting & Coatings",
      "Waterproofing Services",
      "Damp Proofing Solutions",
      "Color Consultation & Design"
    ],
    serviceAreas: ["West Beach", "Bloubergstrand", "Table View", "Milnerton", "Big Bay", "Sunset Beach", "Coastal Areas"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20West%20Beach%20Cape%20Town%2C%20modern%20coastal%20home%20with%20fresh%20white%20walls%20and%20Atlantic%20Ocean%20views%2C%20quality%20paint%20finish%2C%20beachfront%20scenery%20visible%20through%20windows%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work%20with%20contemporary%20furniture&width=400&height=300&seq=westbeach-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20house%20painting%20project%20in%20West%20Beach%20Cape%20Town%20South%20Africa%2C%20coastal%20home%20with%20fresh%20paint%20overlooking%20Atlantic%20Ocean%2C%20professional%20painters%20working%20on%20scaffolding%2C%20quality%20exterior%20finish%2C%20beachfront%20setting%20with%20Table%20Mountain%20views%2C%20well-maintained%20property%20with%20beautiful%20landscaping&width=400&height=300&seq=westbeach-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Beachfront%20house%20painting%20project%20in%20West%20Beach%20Cape%20Town%2C%20professional%20painters%20working%20on%20vacation%20property%20exterior%2C%20quality%20residential%20paint%20finish%2C%20modern%20coastal%20architecture%20with%20ocean%20views%2C%20organized%20work%20site%20with%20painting%20equipment%20and%20materials&width=400&height=300&seq=westbeach-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kitchen%20interior%20painting%20in%20West%20Beach%20coastal%20home%20Cape%20Town%2C%20fresh%20painted%20walls%20in%20modern%20kitchen%2C%20quality%20paint%20finish%20with%20coastal%20color%20scheme%2C%20bright%20clean%20space%20with%20ocean%20views%2C%20professional%20painting%20work%20with%20contemporary%20fixtures%20and%20appliances&width=400&height=300&seq=westbeach-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bedroom%20interior%20painting%20in%20West%20Beach%20beachfront%20home%2C%20fresh%20painted%20walls%20in%20master%20bedroom%2C%20modern%20coastal%20design%20with%20Atlantic%20Ocean%20views%2C%20quality%20paint%20finish%2C%20bright%20airy%20space%2C%20professional%20painting%20work%20with%20elegant%20decor%20and%20natural%20lighting&width=400&height=300&seq=westbeach-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20coastal%20home%20painting%20in%20West%20Beach%20Cape%20Town%2C%20professional%20painters%20applying%20marine-grade%20paint%20to%20beachfront%20property%2C%20Atlantic%20Ocean%20backdrop%20with%20Table%20Mountain%2C%20quality%20exterior%20finish%20with%20weather%20protection%2C%20organized%20professional%20work%20site%20with%20safety%20equipment&width=400&height=300&seq=westbeach-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Andrew Mitchell",
        rating: 5,
        comment: "Excellent work on our West Beach beachfront home. The team was professional and the marine-grade finish has held up perfectly against the harsh Atlantic Ocean conditions."
      },
      {
        name: "Susan Botha", 
        rating: 4,
        comment: "Good quality painting service for our holiday home. They completed the project on schedule and the finish looks great. Would recommend for coastal properties."
      },
      {
        name: "Mark Stevens",
        rating: 5,
        comment: "Professional painters who understand coastal challenges. Great attention to detail and excellent customer service. Our home looks fantastic."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters West Beach | Professional Coastal Painting Services Cape Town | Beachfront Painters";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters West Beach offers professional painting services for coastal properties in West Beach, Cape Town. Specializing in beachfront homes, marine-grade finishes, and Atlantic Ocean properties. Expert coastal painting contractors.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters West Beach, house painters West Beach, coastal painting contractors Cape Town, beachfront property painting, marine-grade finishes');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 to-black text-white py-32 min-h-[70vh] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20stunning%20beachfront%20home%20in%20West%20Beach%20Cape%20Town%20South%20Africa%2C%20spectacular%20Atlantic%20Ocean%20views%20with%20Table%20Mountain%2C%20painters%20in%20clean%20uniforms%20applying%20paint%20with%20brushes%20and%20rollers%2C%20modern%20coastal%20architecture%2C%20bright%20sunny%20day%2C%20pristine%20work%20environment%20with%20professional%20equipment&width=1200&height=600&seq=westbeach-painters-hero-bg&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl">
            <div className="inline-block bg-lime-400 text-black px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-shield-check-line mr-2"></i>
              VERIFIED PROFESSIONAL PAINTER
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Painters West Beach
            </h1>
            <p className="text-2xl text-gray-300 mb-4">
              Beachfront Property & Marine-Grade Painting Specialists
            </p>
            <p className="text-lg text-gray-400 mb-8 leading-relaxed">
              West Beach's premier painting contractors specializing in beachfront homes and coastal properties. With over 14 years of experience serving the Atlantic Seaboard, we deliver exceptional quality using advanced marine-grade finishes designed to withstand the harshest coastal conditions.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content Area */}
            <div className="lg:col-span-2">
              {/* Navigation Tabs */}
              <nav className="flex space-x-8">
                {[
                  { id: 'overview', label: 'Overview' },
                  { id: 'services', label: 'Services' },
                  { id: 'gallery', label: 'Gallery' },
                  { id: 'reviews', label: 'Reviews' },
                  { id: 'contact', label: 'Contact' }
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                      activeTab === tab.id
                        ? 'border-lime-500 text-lime-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>

              {/* Tab Content */}
              <div className="bg-white rounded-xl shadow-lg p-8">
                {activeTab === 'overview' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">About Painters West Beach</h2>
                      <div className="prose prose-lg max-w-none text-gray-700 space-y-4">
                        <p className="leading-relaxed">
                          Welcome to Painters West Beach, the Atlantic Seaboard's most trusted and experienced painting contractor for beachfront properties and coastal homes. For over 14 years, we have been the preferred choice for discerning homeowners throughout West Beach, Bloubergstrand, Table View, and the surrounding coastal areas who demand nothing but the finest in painting craftsmanship and long-lasting protection for their valuable properties.
                        </p>
                        <p className="leading-relaxed">
                          Our reputation has been built on a solid foundation of exceptional quality workmanship, meticulous attention to detail, and an unwavering commitment to customer satisfaction. We understand that beachfront properties represent significant investments and face some of the most challenging environmental conditions imaginable. The combination of direct salt spray from the Atlantic Ocean, strong prevailing winds, intense UV radiation, sand-laden air, and high humidity levels requires specialized expertise, premium marine-grade materials, and proven application techniques that we have perfected over more than a decade of dedicated service in this demanding coastal environment.
                        </p>
                        <p className="leading-relaxed">
                          What truly distinguishes Painters West Beach from other painting contractors is our deep understanding and extensive experience with the unique challenges faced by properties located directly on or near the beachfront. We don't just apply paint; we provide comprehensive protective solutions that are specifically engineered to withstand the relentless assault of coastal elements. Our team has spent years researching, testing, and refining our methods to ensure that every project we complete provides not only stunning aesthetic results but also maximum protection and longevity, even in the most exposed beachfront locations.
                        </p>
                        <p className="leading-relaxed">
                          Our comprehensive approach to every painting project begins with a detailed initial consultation and thorough property assessment. We take the time to understand your specific needs, preferences, budget constraints, and concerns, carefully examining the condition of all surfaces to be painted, identifying any underlying issues such as salt damage, corrosion, moisture penetration, or substrate deterioration that need to be addressed, and considering critical factors such as exposure to prevailing winds, proximity to the ocean, substrate type, previous coating history, and architectural style. Based on this detailed assessment, we provide expert recommendations and a transparent, itemized quote with absolutely no hidden costs or surprises.
                        </p>
                        <p className="leading-relaxed">
                          Surface preparation is absolutely critical for beachfront properties, and it's an area where we never compromise or cut corners. We understand that even the most advanced, expensive marine-grade paint will fail prematurely if applied to poorly prepared surfaces. Our preparation process is exceptionally thorough and meticulous, including high-pressure washing to remove salt deposits and contaminants, scraping of all loose and failing paint, extensive sanding to create proper adhesion profiles, filling and caulking of all cracks and gaps, treatment of any rust or corrosion on metal surfaces, application of specialized primers and sealers, and any necessary repairs to wood, metal, plaster, or other substrates. This attention to detail in the preparation phase is what ensures the longevity, beauty, and protective qualities of the final result.
                        </p>
                        <p className="leading-relaxed">
                          Our team of skilled painters are experienced craftsmen who specialize in working with marine-grade coatings and understand the critical importance of proper application techniques in coastal environments. Each team member has been carefully selected not only for their technical painting skills but also for their reliability, professionalism, work ethic, attention to detail, and commitment to excellence. We invest heavily in ongoing training and professional development to ensure our team stays current with the latest marine coating technologies, application techniques, safety standards, and industry best practices. This dedication to continuous improvement and skill development means you benefit from the most advanced and effective painting solutions available in the market today.
                        </p>
                        <p className="leading-relaxed">
                          Over our 14 years of operation serving the West Beach and Atlantic Seaboard areas, we have built an impressive and diverse portfolio of completed projects. From luxury beachfront estates and modern architectural masterpieces to charming beach cottages and family holiday homes, we have successfully completed hundreds of projects of all sizes, styles, and complexity levels. Each project receives the same level of dedication, professionalism, and attention to detail, regardless of its scope or budget. We treat every home as if it were our own, ensuring that the final result not only meets but consistently exceeds your expectations.
                        </p>
                        <p className="leading-relaxed">
                          At Painters West Beach, we believe in building long-term relationships with our clients based on trust, transparency, reliability, and consistently excellent results. Many of our customers have been with us for years, returning for regular maintenance work, renovations, and new projects. They enthusiastically recommend us to their friends, family, neighbors, and colleagues because they know they can rely on us to deliver superior quality, honest expert advice, fair transparent pricing, and professional service every single time. This loyalty and trust is something we deeply value and never take for granted, and it drives us to maintain our exceptionally high standards on every project, no matter how large or small.
                        </p>
                        <p className="leading-relaxed">
                          We use only the finest premium marine-grade paints and protective coatings from leading manufacturers including specialized marine coating suppliers, Plascon, and Dulux. These products are specifically formulated and engineered to provide superior adhesion, exceptional durability, excellent color retention, and maximum resistance to the extremely harsh coastal conditions found along the Atlantic Seaboard. By investing in the absolute best materials available and applying them with expert technique, proper timing, and meticulous care, we ensure that your paint job not only looks absolutely stunning on completion day but continues to look great and provide reliable protection for many years to come, maximizing the value of your investment and minimizing the need for frequent repainting and maintenance.
                        </p>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Painters West Beach?</h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-award-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">14+ Years Experience</h4>
                            <p className="text-gray-600 text-sm">Over fourteen years of proven excellence in beachfront property painting throughout the Atlantic Seaboard.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-shield-star-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Marine-Grade Specialists</h4>
                            <p className="text-gray-600 text-sm">Extensive expertise in advanced marine-grade coatings specifically designed for extreme coastal exposure.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-shield-check-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Fully Insured & Certified</h4>
                            <p className="text-gray-600 text-sm">Comprehensive liability insurance and professional certifications for your complete peace of mind.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-customer-service-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Outstanding Service</h4>
                            <p className="text-gray-600 text-sm">Professional communication, respect for your property, and unwavering commitment to excellence.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Our Service Areas</h3>
                      <p className="text-gray-700 mb-4 leading-relaxed">
                        Painters West Beach proudly serves the entire Atlantic Seaboard and surrounding areas, including:
                      </p>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        {['West Beach', 'Bloubergstrand', 'Table View', 'Big Bay', 'Sunset Beach', 'Melkbosstrand', 'Dolphin Beach', 'Parklands', 'Sunningdale'].map((area) => (
                          <div key={area} className="flex items-center space-x-2 text-gray-700">
                            <i className="ri-map-pin-line text-lime-600"></i>
                            <span>{area}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'services' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Comprehensive Painting Services</h2>
                      <p className="text-gray-700 mb-8 leading-relaxed">
                        At Painters West Beach, we offer a complete range of professional painting services specifically designed for beachfront properties and coastal homes. Our expertise encompasses every aspect of marine-grade painting, from initial consultation through to final inspection and ongoing maintenance support.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-ship-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Marine-Grade Exterior Coating</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Our flagship service uses the most advanced marine-grade coatings available to protect beachfront properties from salt spray, UV radiation, wind, and moisture. These specialized systems provide unmatched durability and protection in the harshest coastal environments.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Advanced marine-grade protective coating systems</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Salt and corrosion-resistant finishes</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>UV-resistant and fade-proof coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Multi-layer protective systems for maximum durability</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-home-4-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Beachfront Interior Painting</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Transform your beachfront home's interior with our premium painting services. We use moisture-resistant and mold-resistant coatings specifically designed for high-humidity coastal environments, ensuring beautiful and durable results.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Living areas with moisture-resistant coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Kitchens and bathrooms with anti-mold finishes</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Ceilings, cornices, and architectural details</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Doors, windows, and trim work</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-shield-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Waterproofing & Sealing</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Critical for beachfront properties, our comprehensive waterproofing services protect your investment from water damage, salt penetration, and structural deterioration. We use advanced waterproofing systems designed for extreme coastal exposure.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Exterior wall waterproofing and salt barrier systems</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Roof waterproofing and protective coating systems</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Balcony and deck waterproofing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Advanced moisture barrier installation</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-tools-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Corrosion Treatment & Prevention</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Specialized services to treat existing corrosion and prevent future damage on metal surfaces, railings, gates, and structural elements. Essential for maintaining the integrity and appearance of beachfront properties.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Rust removal and surface treatment</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Anti-corrosion primer application</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Marine-grade metal coating systems</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Ongoing corrosion prevention maintenance</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'gallery' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Project Gallery</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {painter.gallery.map((image, index) => (
                        <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                          <img 
                            src={image} 
                            alt={`${painter.name} project ${index + 1}`}
                            className="w-full h-64 object-cover object-top"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'reviews' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews</h2>
                    <div className="space-y-6">
                      {painter.testimonials.map((testimonial, index) => (
                        <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                          <div className="flex items-center mb-4">
                            <div className="flex items-center">
                              {[...Array(5)].map((_, i) => (
                                <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                              ))}
                            </div>
                            <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                          </div>
                          <p className="text-gray-700">{testimonial.comment}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'contact' && (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Information</h2>
                      <div className="space-y-6">
                        <div className="flex items-center">
                          <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Email</h3>
                            <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                              {painter.email}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-center">
                          <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Website</h3>
                            <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                              {painter.website}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-start">
                          <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Service Area</h3>
                            <p className="text-gray-700">{painter.location} and surrounding areas</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Get a Quote</h3>
                      <button 
                        onClick={() => navigate('/quote')}
                        className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                      >
                        Request Free Quote
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* Sidebar */}
            <div>
              <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                <div className="mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20coastal%20home%20in%20West%20Beach%20Cape%20Town%2C%20Atlantic%20Ocean%20beachfront%20property%20with%20Table%20Mountain%20views%2C%20painters%20in%20uniform%20with%20quality%20equipment%2C%20modern%20coastal%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=westbeach-sidebar-image&orientation=landscape"
                    alt="Professional painters West Beach coastal house painting services Cape Town Atlantic Ocean"
                    className="w-full h-48 object-cover object-top rounded-lg"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <i className="ri-mail-line mr-3 text-lime-500"></i>
                    <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                      {painter.email}
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-global-line mr-3 text-lime-500"></i>
                    <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                      Visit Website
                    </a>
                  </div>
                </div>
                
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Get Free Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
